var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteFeedback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.772,
    height: 21.5,
    viewBox: "0 0 18.772 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49886",
    "data-name": "Group 49886",
    transform: "translate(-3868 -4261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93732",
    "data-name": "Path 93732",
    d: "M13.477,20.75H4.386A3.636,3.636,0,0,1,.75,17.114V4.386A3.636,3.636,0,0,1,4.386.75h10a3.636,3.636,0,0,1,3.636,3.636V16.2A4.545,4.545,0,0,1,13.477,20.75Z",
    transform: "translate(3868 4261)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93733",
    "data-name": "Path 93733",
    d: "M13.477,20.75h-.909V18.023A2.727,2.727,0,0,1,15.3,15.3h2.727v.91A4.545,4.545,0,0,1,13.477,20.75Z",
    transform: "translate(3868 4261)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_617",
    "data-name": "Line 617",
    x2: 8.182,
    transform: "translate(3873.295 4267.205)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_618",
    "data-name": "Line 618",
    x2: 6.364,
    transform: "translate(3873.295 4271.75)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteFeedback);
export default __webpack_public_path__ + "static/media/write-feedback.a145adcdeec40fa372c2bed6a4073305.svg";
export { ForwardRef as ReactComponent };